(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["altar-bundle-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('altar-bundle-showcase')) {
  customElements.define('altar-bundle-showcase', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this.querySelectorAll('.ab-breakdown').forEach(button => {
        button.addEventListener('click', () => this._toggle(button), { signal });
      });
      document.addEventListener('shopify:block:select', event => {
        if (String(event.detail.sectionId) !== this.dataset.sectionId) return;
        const card = Array.from(this.querySelectorAll('.ab-bundle')).find(element => element.dataset.blockId === String(event.detail.blockId));
        if (card) this._toggle(card.querySelector('.ab-breakdown'), true);
      }, { signal });
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._abort = null;
    }
    _toggle(button, forceOpen) {
      const card = button.closest('.ab-bundle');
      const open = typeof forceOpen === 'boolean' ? forceOpen : !card.classList.contains('is-open');
      card.classList.toggle('is-open', open);
      const label = open ? this.dataset.collapseLabel : this.dataset.expandLabel;
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', label + ': ' + button.dataset.title);
      button.querySelector('.ab-breakdown-label').textContent = label;
      button.querySelector('.ab-toggle-sign').textContent = open ? '−' : '+';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["altar-countdown"] && !Shopify.designMode) return;
  try {
    
  function initAltarCountdown(root) {
    if (!root || root.dataset.countdownInitialized === 'true') return;

    root.dataset.countdownInitialized = 'true';

    const display = root.querySelector('[data-countdown-display]');
    const expiredMessage = root.querySelector('[data-countdown-expired]');
    const errorMessage = root.querySelector('[data-countdown-error]');
    const daysNode = root.querySelector('[data-countdown-days]');
    const hoursNode = root.querySelector('[data-countdown-hours]');
    const minutesNode = root.querySelector('[data-countdown-minutes]');
    const secondsNode = root.querySelector('[data-countdown-seconds]');

    const date = root.dataset.targetDate || '';
    const time = root.dataset.targetTime || '';
    const offset = root.dataset.targetOffset || '';
    const hideAfter = root.dataset.hideAfter === 'true';

    const datePattern = /^\d{4}-\d{2}-\d{2}$/;
    const timePattern = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
    const offsetPattern = /^(?:Z|[+-](?:0\d|1[0-4]):[0-5]\d)$/;

    if (!datePattern.test(date) || !timePattern.test(time) || !offsetPattern.test(offset)) {
      display.hidden = true;
      errorMessage.hidden = false;
      return;
    }

    const target = new Date(`${date}T${time}:00${offset}`);

    if (Number.isNaN(target.getTime())) {
      display.hidden = true;
      errorMessage.hidden = false;
      return;
    }

    const pad = (value) => String(value).padStart(2, '0');

    const update = () => {
      const remaining = target.getTime() - Date.now();

      if (remaining <= 0) {
        daysNode.textContent = '00';
        hoursNode.textContent = '00';
        minutesNode.textContent = '00';
        secondsNode.textContent = '00';

        if (hideAfter) {
          root.hidden = true;
        } else {
          display.hidden = true;
          expiredMessage.hidden = false;
        }

        if (root.__altarCountdownTimer) {
          window.clearInterval(root.__altarCountdownTimer);
          root.__altarCountdownTimer = null;
        }
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      daysNode.textContent = pad(days);
      hoursNode.textContent = pad(hours);
      minutesNode.textContent = pad(minutes);
      secondsNode.textContent = pad(seconds);
    };

    update();
    root.__altarCountdownTimer = window.setInterval(update, 1000);
  }

  function initAllAltarCountdowns(scope) {
    if (scope.matches && scope.matches('[data-altar-countdown]')) {
      initAltarCountdown(scope);
    }

    scope.querySelectorAll('[data-altar-countdown]').forEach(initAltarCountdown);
  }

  initAllAltarCountdowns(document);

  document.addEventListener('shopify:section:load', (event) => {
    initAllAltarCountdowns(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches('[data-altar-countdown]')
      ? event.target
      : event.target.querySelector('[data-altar-countdown]');

    if (root && root.__altarCountdownTimer) {
      window.clearInterval(root.__altarCountdownTimer);
      root.__altarCountdownTimer = null;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["altar-gel-converter"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const roundSmart = (value, decimals = 1) => {
      if (!Number.isFinite(value)) return '0';
      const rounded = Number(value.toFixed(decimals));
      return rounded.toString();
    };

    const roundToHalf = (value) => {
      if (!Number.isFinite(value)) return 0;
      return Math.round(value * 2) / 2;
    };

    const formatHalfStep = (value) => {
      if (!Number.isFinite(value)) return '0';
      const rounded = roundToHalf(value);
      if (Math.abs(rounded - Math.round(rounded)) < 0.001) return String(Math.round(rounded));
      return rounded.toFixed(1).replace(/\.0$/, '');
    };

    const gelSvg = () => `
      <svg viewBox="0 0 88 156" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M26 10C26 7.8 27.8 6 30 6H58C60.2 6 62 7.8 62 10V20H66.5C69 20 71 22 71 24.5V32.5C71 35.3 70.3 38.1 68.9 40.5L64 48V128C64 138.5 55.5 147 45 147H43C32.5 147 24 138.5 24 128V48L19.1 40.5C17.7 38.1 17 35.3 17 32.5V24.5C17 22 19 20 21.5 20H26V10Z" fill="currentColor"/>
        <path d="M26 20H62" stroke="rgba(255,255,255,0.32)" stroke-width="2.6" stroke-linecap="round"/>
        <path d="M22 34H66" stroke="rgba(255,255,255,0.28)" stroke-width="2.2" stroke-linecap="round"/>
        <path d="M28 51C33 55 39 57 44 57C49 57 55 55 60 51" stroke="rgba(255,255,255,0.18)" stroke-width="2" stroke-linecap="round"/>
        <path d="M24 129H64" stroke="rgba(255,255,255,0.28)" stroke-width="2.2" stroke-linecap="round"/>
        <path d="M28 137H60" stroke="rgba(255,255,255,0.22)" stroke-width="1.8" stroke-linecap="round"/>
      </svg>
    `;

    const bottleSvgMarkup = (fillRatio = 1, key = 'x') => {
      const ratio = clamp(fillRatio, 0, 1);
      const minY = 32;
      const maxY = 145;
      const liquidTop = maxY - ((maxY - minY) * ratio);
      const y1 = liquidTop;
      const y2 = liquidTop + 3;
      const y3 = liquidTop - 2;
      const y4 = liquidTop + 2;
      return `
        <svg viewBox="0 0 90 170" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
          <defs>
            <clipPath id="gc-bottle-clip-${key}">
              <path d="M34 7H56V20L60 28V38.5C60 40.7 61.1 42.8 62.9 44.1L69 48.5C73.4 51.7 76 56.8 76 62.2V145C76 152.2 70.2 158 63 158H27C19.8 158 14 152.2 14 145V62.2C14 56.8 16.6 51.7 21 48.5L27.1 44.1C28.9 42.8 30 40.7 30 38.5V28L34 20V7Z" />
            </clipPath>
          </defs>
          <path d="M34 7H56V20L60 28V38.5C60 40.7 61.1 42.8 62.9 44.1L69 48.5C73.4 51.7 76 56.8 76 62.2V145C76 152.2 70.2 158 63 158H27C19.8 158 14 152.2 14 145V62.2C14 56.8 16.6 51.7 21 48.5L27.1 44.1C28.9 42.8 30 40.7 30 38.5V28L34 20V7Z" stroke="currentColor" stroke-width="4"/>
          <path d="M39 7H51" stroke="currentColor" stroke-width="4" stroke-linecap="round"/>
          <path d="M31 24H59" stroke="currentColor" stroke-width="3" stroke-linecap="round" opacity="0.95"/>
          <g clip-path="url(#gc-bottle-clip-${key})">
            <path d="M18 ${y1} C 25 ${y2}, 34 ${y3}, 45 ${y4} C 56 ${y2}, 65 ${y3}, 72 ${y1} L72 160L18 160Z" fill="currentColor" opacity="0.20"/>
            <path d="M18 ${y1} C 25 ${y2}, 34 ${y3}, 45 ${y4} C 56 ${y2}, 65 ${y3}, 72 ${y1}" stroke="currentColor" stroke-width="3.2" stroke-linecap="round"/>
          </g>
        </svg>
      `;
    };

    const renderGelIcons = (container, totalGels) => {
      if (!container) return;
      const iconCount = Math.max(0, Math.round(totalGels));
      const maxIcons = 12;
      const visibleCount = Math.min(iconCount, maxIcons);
      const overflowCount = Math.max(iconCount - maxIcons, 0);
      let markup = '';

      for (let i = 0; i < visibleCount; i += 1) {
        markup += `<div class="altar-gel-converter__gel-icon">${gelSvg()}</div>`;
      }

      if (overflowCount > 0) {
        markup += `<div class="altar-gel-converter__gel-overflow">+${overflowCount}</div>`;
      }

      if (markup === '') {
        markup = `<div class="altar-gel-converter__gel-overflow">0</div>`;
      }

      container.innerHTML = markup;
    };

    const renderBottleIcons = (container, totalServings) => {
      if (!container) return;
      const clamped = Math.max(0, totalServings);
      const fullCount = Math.floor(clamped);
      const hasHalf = Math.abs(clamped - fullCount - 0.5) < 0.001;
      const totalIcons = fullCount + (hasHalf ? 1 : 0);
      const maxIcons = 8;
      const visibleIcons = Math.min(totalIcons, maxIcons);
      const overflowCount = Math.max(totalIcons - maxIcons, 0);
      let markup = '';

      for (let i = 0; i < visibleIcons; i += 1) {
        const isHalf = hasHalf && i === visibleIcons - 1 && i >= fullCount;
        const fillRatio = isHalf ? 0.5 : 0.92;
        markup += `<div class="altar-gel-converter__bottle-icon">${bottleSvgMarkup(fillRatio, `${i}-${visibleIcons}-${Math.round(clamped * 10)}`)}</div>`;
      }

      if (overflowCount > 0) {
        markup += `<div class="altar-gel-converter__bottle-overflow">+${overflowCount}</div>`;
      }

      if (markup === '') {
        markup = `<div class="altar-gel-converter__bottle-overflow">0</div>`;
      }

      container.innerHTML = markup;
    };

    const initGelConverter = (root) => {
      if (!root || root.dataset.gcInitialized === 'true') return;
      root.dataset.gcInitialized = 'true';

      const gelsInput = root.querySelector('[data-gc-gels]');
      const carbsInput = root.querySelector('[data-gc-carbs]');
      const hoursInput = root.querySelector('[data-gc-hours]');
      const minutesInput = root.querySelector('[data-gc-minutes]');
      const gelOutput = root.querySelector('[data-gc-gels-output]');
      const presets = root.querySelectorAll('[data-gc-preset]');

      const hourlyCarbsEl = root.querySelector('[data-gc-hourly-carbs]');
      const totalGelsEl = root.querySelector('[data-gc-total-gels]');
      const totalCarbsEl = root.querySelector('[data-gc-total-carbs]');
      const servingsHourEl = root.querySelector('[data-gc-servings-hour]');
      const resultTotalCarbsEl = root.querySelector('[data-gc-result-total-carbs]');
      const totalServingsEl = root.querySelector('[data-gc-total-servings]');
      const gelsReplacedEl = root.querySelector('[data-gc-gels-replaced]');
      const visualGelCountEl = root.querySelector('[data-gc-visual-gel-count]');
      const visualServingCountEl = root.querySelector('[data-gc-visual-serving-count]');
      const visualServingHourEl = root.querySelector('[data-gc-visual-serving-hour]');
      const visualServingTotalEl = root.querySelector('[data-gc-visual-serving-total]');
      const gelIcons = root.querySelector('[data-gc-gel-icons]');
      const bottleIcons = root.querySelector('[data-gc-bottle-icons]');

      const carbsPerServing = Number(root.dataset.carbsPerServing) || 71;

      const getNumber = (input, fallback = 0) => {
        const parsed = Number(input?.value);
        return Number.isFinite(parsed) ? parsed : fallback;
      };

      const calculate = () => {
        const gelsPerHour = clamp(getNumber(gelsInput, 0), 0, 20);
        const carbsPerGel = clamp(getNumber(carbsInput, 0), 0, 100);
        const hours = clamp(getNumber(hoursInput, 0), 0, 100);
        const minutes = clamp(getNumber(minutesInput, 0), 0, 59);
        const durationHours = hours + (minutes / 60);

        const hourlyCarbs = gelsPerHour * carbsPerGel;
        const totalGels = gelsPerHour * durationHours;
        const totalCarbs = hourlyCarbs * durationHours;
        const servingsPerHourRaw = carbsPerServing > 0 ? hourlyCarbs / carbsPerServing : 0;
        const totalServingsRaw = carbsPerServing > 0 ? totalCarbs / carbsPerServing : 0;
        const servingsPerHourRounded = roundToHalf(servingsPerHourRaw);
        const totalServingsRounded = roundToHalf(totalServingsRaw);

        if (gelOutput) gelOutput.textContent = roundSmart(gelsPerHour, 1);
        if (hourlyCarbsEl) hourlyCarbsEl.textContent = roundSmart(hourlyCarbs, 0);
        if (totalGelsEl) totalGelsEl.textContent = roundSmart(totalGels, 1);
        if (totalCarbsEl) totalCarbsEl.textContent = roundSmart(totalCarbs, 0);
        if (servingsHourEl) servingsHourEl.textContent = formatHalfStep(servingsPerHourRounded);
        if (resultTotalCarbsEl) resultTotalCarbsEl.textContent = roundSmart(totalCarbs, 0);
        if (totalServingsEl) totalServingsEl.textContent = formatHalfStep(totalServingsRounded);
        if (gelsReplacedEl) gelsReplacedEl.textContent = roundSmart(totalGels, 1);

        if (visualGelCountEl) visualGelCountEl.textContent = String(Math.round(totalGels));
        if (visualServingCountEl) visualServingCountEl.textContent = formatHalfStep(totalServingsRounded);
        if (visualServingHourEl) visualServingHourEl.textContent = formatHalfStep(servingsPerHourRounded);
        if (visualServingTotalEl) visualServingTotalEl.textContent = formatHalfStep(totalServingsRounded);

        renderGelIcons(gelIcons, totalGels);
        renderBottleIcons(bottleIcons, totalServingsRounded);

        presets.forEach((preset) => {
          preset.classList.toggle('is-active', Number(preset.dataset.gcPreset) === carbsPerGel);
        });
      };

      [gelsInput, carbsInput, hoursInput, minutesInput].forEach((input) => {
        input?.addEventListener('input', calculate);
        input?.addEventListener('change', calculate);
      });

      presets.forEach((preset) => {
        preset.addEventListener('click', () => {
          if (!carbsInput) return;
          carbsInput.value = preset.dataset.gcPreset || carbsInput.value;
          carbsInput.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });

      const variantSelect = root.querySelector('[data-gc-variant]');
      const productPrice = root.querySelector('[data-gc-product-price]');

      variantSelect?.addEventListener('change', () => {
        const selectedOption = variantSelect.options?.[variantSelect.selectedIndex];
        if (selectedOption?.dataset.price && productPrice) {
          productPrice.textContent = selectedOption.dataset.price;
        }
      });

      const addButton = root.querySelector('[data-gc-add]');
      const cartStatus = root.querySelector('[data-gc-cart-status]');

      addButton?.addEventListener('click', async () => {
        const variantId = Number(variantSelect?.value);
        if (!variantId || addButton.disabled) return;

        const defaultLabel = addButton.dataset.defaultLabel || 'Add to cart';
        const addingLabel = addButton.dataset.addingLabel || 'Adding…';
        const addedLabel = addButton.dataset.addedLabel || 'Added';
        const errorLabel = addButton.dataset.errorLabel || 'Something went wrong';

        addButton.disabled = true;
        addButton.textContent = addingLabel;
        if (cartStatus) cartStatus.textContent = '';

        try {
          const routeRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${routeRoot}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              items: [{ id: variantId, quantity: 1 }]
            })
          });

          const data = await response.json();
          if (!response.ok) {
            throw new Error(data?.description || data?.message || errorLabel);
          }

          addButton.textContent = addedLabel;
          if (cartStatus) cartStatus.textContent = addedLabel;

          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { source: 'gel-converter' } }));

          if (root.dataset.redirectAfterAdd === 'true') {
            window.location.href = root.dataset.cartUrl || `${routeRoot}cart`;
            return;
          }

          window.setTimeout(() => {
            addButton.disabled = false;
            addButton.textContent = defaultLabel;
          }, 1800);
        } catch (error) {
          addButton.disabled = false;
          addButton.textContent = defaultLabel;
          if (cartStatus) cartStatus.textContent = error?.message || errorLabel;
        }
      });

      calculate();
    };

    const initAllGelConverters = (scope = document) => {
      scope.querySelectorAll('[data-gel-converter]').forEach(initGelConverter);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllGelConverters());
    } else {
      initAllGelConverters();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllGelConverters(event.target);
      if (event.target.matches?.('[data-gel-converter]')) initGelConverter(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["altar-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('altar-speed-hero')) {
  customElements.define('altar-speed-hero', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      this._timer = null;
      const signal = this._abort.signal;
      this._options = Array.from(this.querySelectorAll('.af-option'));
      this._bags = Array.from(this.querySelectorAll('.af-bag'));
      this._current = Number(this.dataset.initialIndex) || 0;
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._autoplay = this.dataset.autoplay === 'true' && !this._motion.matches && !window.Shopify?.designMode && this._options.length > 1;
      this._visible = true;
      this._hovered = false;
      this._focused = false;
      this._interval = Math.max(4000, Number(this.dataset.interval) || 6500);
      this._options.forEach((option, index) => {
        option.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          this._select(index, true);
        }, { signal });
      });
      this.querySelector('.af-prev')?.addEventListener('click', () => this._select(this._current - 1, true), { signal });
      this.querySelector('.af-next')?.addEventListener('click', () => this._select(this._current + 1, true), { signal });
      this.querySelector('.af-auto')?.addEventListener('click', () => {
        this._autoplay = !this._autoplay && !this._motion.matches;
        this._playback();
      }, { signal });
      this.querySelector('.af-shop')?.addEventListener('click', () => {
        this._autoplay = false;
        this._playback();
      }, { signal });
      this.addEventListener('mouseenter', () => { this._hovered = true; this._schedule(); }, { signal });
      this.addEventListener('mouseleave', () => { this._hovered = false; this._schedule(); }, { signal });
      this.addEventListener('focusin', () => { this._focused = true; this._schedule(); }, { signal });
      this.addEventListener('focusout', event => {
        if (!this.contains(event.relatedTarget)) { this._focused = false; this._schedule(); }
      }, { signal });
      document.addEventListener('visibilitychange', () => this._schedule(), { signal });
      this._motion.addEventListener('change', () => {
        if (this._motion.matches) this._autoplay = false;
        this._playback();
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        if (String(event.detail.sectionId) !== this.dataset.sectionId) return;
        const index = this._options.findIndex(option => option.dataset.blockId === String(event.detail.blockId));
        if (index >= 0) this._select(index, true);
      }, { signal });
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => {
          this._visible = entries[0].isIntersecting;
          this._schedule();
        }, { threshold: 0.1 });
        this._observer.observe(this);
      }
      this.querySelector('.af-playback')?.removeAttribute('hidden');
      this._select(this._current, false);
      this._playback();
    }
    disconnectedCallback() {
      clearInterval(this._timer);
      this._observer?.disconnect();
      this._abort?.abort();
      this._abort = null;
    }
    _select(index, manual) {
      const count = this._options.length;
      if (!count) return;
      this._current = (index + count) % count;
      const option = this._options[this._current];
      const data = option.dataset;
      this.style.setProperty('--af-accent', data.accent);
      this.style.setProperty('--af-tint', data.tint);
      this._bags.forEach((bag, i) => {
        const relative = (i - this._current + count) % count;
        bag.dataset.position = relative === 0 ? 'active' : relative === 1 ? 'after' : relative === count - 1 ? 'before' : 'hidden';
        bag.setAttribute('aria-hidden', String(relative !== 0));
        this._options[i].setAttribute('aria-current', String(relative === 0));
      });
      this.querySelector('.af-caption').setAttribute('aria-live', manual ? 'polite' : 'off');
      this.querySelector('.af-flavour-name').textContent = data.flavour;
      this.querySelector('.af-buy-flavour').textContent = data.flavour;
      this.querySelector('.af-flavour-note').textContent = data.description;
      const counter = this.querySelector('.af-count');
      if (counter) counter.textContent = String(this._current + 1).padStart(2, '0') + ' / ' + String(count).padStart(2, '0');
      this.querySelector('.af-shop').href = option.href;
      this.querySelector('.af-shop-label').textContent = (data.available === 'true' ? this.dataset.shopLabel : this.dataset.viewLabel) + ' ' + data.flavour;
      const price = this.querySelector('.af-price');
      price.textContent = data.price;
      price.hidden = data.known !== 'true';
      const status = this.querySelector('.af-shop-status');
      status.setAttribute('aria-live', manual ? 'polite' : 'off');
      status.textContent = data.known === 'true' && data.available !== 'true' ? this.dataset.soldOutLabel : '';
      if (manual) { this._autoplay = false; this._playback(); }
    }
    _playback() {
      const control = this.querySelector('.af-auto');
      if (control) {
        control.textContent = this._autoplay ? this.dataset.pauseLabel : this.dataset.playLabel;
        control.setAttribute('aria-pressed', String(this._autoplay));
        control.hidden = this._motion.matches;
      }
      this._schedule();
    }
    _schedule() {
      clearInterval(this._timer);
      this._timer = null;
      if (this._abort && this._autoplay && !this._hovered && !this._focused && this._visible && !document.hidden) {
        this._timer = setInterval(() => this._select(this._current + 1, false), this._interval);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["altar-running-calculators"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const KM_PER_MILE = 1.609344;
    const STANDARD_DISTANCES = [
      { label: '5K', km: 5 },
      { label: '10K', km: 10 },
      { label: '10 Mile', km: 16.09344 },
      { label: 'Half Marathon', km: 21.0975 },
      { label: 'Marathon', km: 42.195 }
    ];

    const TARGET_LABELS = {
      '5': '5K',
      '10': '10K',
      '16.09344': '10 Mile',
      '21.0975': 'Half Marathon',
      '42.195': 'Marathon'
    };

    const TRAINING_ZONES = [
      { name: 'Easy / recovery', low: 0.59, high: 0.74, purpose: 'Conversational aerobic running and recovery mileage.' },
      { name: 'Steady aerobic', low: 0.75, high: 0.80, purpose: 'Controlled aerobic work; purposeful but sustainable.' },
      { name: 'Marathon / strong aerobic', low: 0.80, high: 0.85, purpose: 'Sustained aerobic work around marathon-style effort.' },
      { name: 'Threshold', low: 0.85, high: 0.88, purpose: 'Tempo and threshold intervals; controlled discomfort.' },
      { name: 'Interval', low: 0.95, high: 1.00, purpose: 'Shorter aerobic-power repetitions with recovery.' }
    ];

    function numberValue(input, fallback = 0) {
      const value = Number.parseFloat(input?.value ?? '');
      return Number.isFinite(value) ? value : fallback;
    }

    function clamp(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function roundTo(value, step) {
      return Math.round(value / step) * step;
    }

    function formatDuration(totalSeconds) {
      const seconds = Math.max(0, Math.round(totalSeconds));
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secs = seconds % 60;

      if (hours > 0) {
        return `${hours}:${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
      }
      return `${minutes}:${String(secs).padStart(2, '0')}`;
    }

    function formatPace(secondsPerUnit) {
      const seconds = Math.max(0, Math.round(secondsPerUnit));
      const minutes = Math.floor(seconds / 60);
      const secs = seconds % 60;
      return `${minutes}:${String(secs).padStart(2, '0')}`;
    }

    function riegelPrediction(sourceSeconds, sourceKm, targetKm) {
      return sourceSeconds * Math.pow(targetKm / sourceKm, 1.06);
    }

    function vdotFromPerformance(distanceKm, totalSeconds) {
      const timeMinutes = totalSeconds / 60;
      const velocity = (distanceKm * 1000) / timeMinutes;
      const oxygenCost = -4.60 + (0.182258 * velocity) + (0.000104 * velocity * velocity);
      const fraction = 0.8 + (0.1894393 * Math.exp(-0.012778 * timeMinutes)) + (0.2989558 * Math.exp(-0.1932605 * timeMinutes));
      return oxygenCost / fraction;
    }

    function paceSecondsPerKmForVDOT(vdot, fraction) {
      const targetOxygen = vdot * fraction;
      const a = 0.000104;
      const b = 0.182258;
      const c = -4.60 - targetOxygen;
      const discriminant = (b * b) - (4 * a * c);
      if (discriminant <= 0) return null;
      const velocity = (-b + Math.sqrt(discriminant)) / (2 * a);
      if (!Number.isFinite(velocity) || velocity <= 0) return null;
      return (1000 / velocity) * 60;
    }

    function createCell(text) {
      const td = document.createElement('td');
      td.textContent = text;
      return td;
    }

    function getFuelRange(durationMinutes, activity, purpose, raceDistanceKm) {
      const isRunningRace = activity === 'running' && purpose === 'race';

      // Marathon and ultra racing are treated as prolonged endurance events even when
      // a faster athlete finishes close to the traditional 2.5-hour duration boundary.
      if (isRunningRace && Number.isFinite(raceDistanceKm) && raceDistanceKm >= 42.195) {
        return { low: 60, high: 90, label: '60–90 g/h' };
      }

      if (durationMinutes <= 45) return { low: 0, high: 0, label: '0 g/h' };
      if (durationMinutes <= 75) return { low: 0, high: 30, label: '0–30 g/h' };
      if (durationMinutes <= 150) return { low: 30, high: 60, label: '30–60 g/h' };
      return { low: 60, high: 90, label: '60–90 g/h' };
    }

    function fuelTarget(range, intensity, experience, purpose, durationMinutes, activity, raceDistanceKm) {
      if (range.high === 0) return 0;

      const isRunningRace = activity === 'running' && purpose === 'race';
      const isMarathonOrLonger = isRunningRace && Number.isFinite(raceDistanceKm) && raceDistanceKm >= 42.195;

      if (isMarathonOrLonger) {
        // For marathon/ultra racing, keep the public recommendation within the
        // established 60–90 g/h performance range and let gut-training experience
        // determine how aggressively the athlete should sit within that range.
        if (experience === 'new') return 60;
        if (experience === 'trained') return 90;

        // A faster marathon is a high carbohydrate-demand race despite its shorter
        // elapsed time. Use 85 g/h for an experienced-but-not-fully-gut-trained
        // athlete at sub-3-hour marathon duration; otherwise use 80 g/h.
        return durationMinutes <= 180 ? 85 : 80;
      }

      const experiencePosition = {
        new: 0.22,
        some: 0.55,
        trained: 0.82
      }[experience] ?? 0.55;

      const intensityAdjustment = {
        easy: -0.16,
        moderate: -0.02,
        hard: 0.08,
        race: 0.14
      }[intensity] ?? 0;

      const purposeAdjustment = purpose === 'race' ? 0.04 : 0;
      let position = clamp(experiencePosition + intensityAdjustment + purposeAdjustment, 0, 1);

      if (durationMinutes <= 75 && intensity === 'easy' && purpose === 'training') {
        position = 0;
      }

      const target = range.low + ((range.high - range.low) * position);
      return clamp(roundTo(target, 5), range.low, range.high);
    }

    function initializeCalculator(root) {
      if (!root || root.dataset.altarInitialized === 'true') return;
      root.dataset.altarInitialized = 'true';

      const tabs = [...root.querySelectorAll('[data-calculator-tab]')];
      const panels = [...root.querySelectorAll('[data-calculator-panel]')];

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          const target = tab.dataset.calculatorTab;
          tabs.forEach((candidate) => {
            const active = candidate === tab;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          panels.forEach((panel) => {
            panel.hidden = panel.dataset.calculatorPanel !== target;
          });
        });
      });

      const raceForm = root.querySelector('[data-race-form]');
      const raceDistance = root.querySelector('[data-race-distance]');
      const customRaceWrap = root.querySelector('[data-custom-race-distance-wrap]');
      const customRaceDistance = root.querySelector('[data-custom-race-distance]');
      const raceError = root.querySelector('[data-race-error]');
      const raceResults = root.querySelector('[data-race-results]');

      function syncCustomRaceDistance() {
        const custom = raceDistance?.value === 'custom';
        if (customRaceWrap) customRaceWrap.hidden = !custom;
        if (customRaceDistance) customRaceDistance.required = custom;
      }

      raceDistance?.addEventListener('change', syncCustomRaceDistance);
      syncCustomRaceDistance();

      raceForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!raceResults || !raceError) return;

        raceError.hidden = true;
        raceError.textContent = '';

        const sourceKm = raceDistance.value === 'custom'
          ? numberValue(customRaceDistance, 0)
          : Number.parseFloat(raceDistance.value);

        const hours = numberValue(root.querySelector('[data-race-hours]'), 0);
        const minutes = numberValue(root.querySelector('[data-race-minutes]'), 0);
        const seconds = numberValue(root.querySelector('[data-race-seconds]'), 0);
        const totalSeconds = (hours * 3600) + (minutes * 60) + seconds;
        const targetKm = Number.parseFloat(root.querySelector('[data-target-distance]')?.value ?? '42.195');

        if (!Number.isFinite(sourceKm) || sourceKm < 0.4 || sourceKm > 100) {
          raceError.textContent = 'Enter a valid race distance between 0.4 km and 100 km.';
          raceError.hidden = false;
          raceResults.hidden = true;
          return;
        }

        if (minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59 || totalSeconds <= 0) {
          raceError.textContent = 'Enter a valid finish time.';
          raceError.hidden = false;
          raceResults.hidden = true;
          return;
        }

        const sourcePace = totalSeconds / sourceKm;
        if (sourcePace < 120 || sourcePace > 900) {
          raceError.textContent = 'That result looks unusual. Check the distance and finish time entered.';
          raceError.hidden = false;
          raceResults.hidden = true;
          return;
        }

        const targetSeconds = riegelPrediction(totalSeconds, sourceKm, targetKm);
        const targetPaceKm = targetSeconds / targetKm;
        const targetPaceMile = targetPaceKm * KM_PER_MILE;
        const vdot = vdotFromPerformance(sourceKm, totalSeconds);

        root.querySelector('[data-target-label]').textContent = TARGET_LABELS[String(targetKm)] || `${targetKm.toFixed(2)} km`;
        root.querySelector('[data-target-time]').textContent = formatDuration(targetSeconds);
        root.querySelector('[data-target-pace-km]').textContent = `${formatPace(targetPaceKm)} /km`;
        root.querySelector('[data-target-pace-mile]').textContent = `${formatPace(targetPaceMile)} /mi`;
        root.querySelector('[data-fitness-index]').textContent = Number.isFinite(vdot) ? vdot.toFixed(1) : '—';

        const equivalentsBody = root.querySelector('[data-equivalents-body]');
        equivalentsBody.replaceChildren();
        STANDARD_DISTANCES.forEach((distance) => {
          const predicted = riegelPrediction(totalSeconds, sourceKm, distance.km);
          const paceKm = predicted / distance.km;
          const row = document.createElement('tr');
          row.append(
            createCell(distance.label),
            createCell(formatDuration(predicted)),
            createCell(`${formatPace(paceKm)} /km`),
            createCell(`${formatPace(paceKm * KM_PER_MILE)} /mi`)
          );
          equivalentsBody.appendChild(row);
        });

        const zonesWrap = root.querySelector('[data-training-zones]');
        zonesWrap.replaceChildren();
        TRAINING_ZONES.forEach((zone) => {
          const slowPace = paceSecondsPerKmForVDOT(vdot, zone.low);
          const fastPace = paceSecondsPerKmForVDOT(vdot, zone.high);
          if (!slowPace || !fastPace) return;

          const item = document.createElement('div');
          item.className = 'altar-calculators__zone';

          const name = document.createElement('strong');
          name.textContent = zone.name;

          const pace = document.createElement('div');
          const meta = document.createElement('span');
          meta.className = 'altar-calculators__zone-meta';
          meta.textContent = 'Suggested range';
          const paceStrong = document.createElement('strong');
          paceStrong.textContent = `${formatPace(fastPace)}–${formatPace(slowPace)} /km`;
          pace.append(meta, paceStrong);

          const purpose = document.createElement('p');
          purpose.textContent = zone.purpose;

          item.append(name, pace, purpose);
          zonesWrap.appendChild(item);
        });

        const splitsWrap = root.querySelector('[data-splits]');
        splitsWrap.replaceChildren();
        const interval = targetKm <= 10 ? 1 : 5;
        const checkpoints = [];
        for (let checkpoint = interval; checkpoint < targetKm; checkpoint += interval) {
          checkpoints.push(Number(checkpoint.toFixed(4)));
        }
        if (targetKm >= 21.0975 && !checkpoints.some((value) => Math.abs(value - 21.0975) < 0.01)) {
          checkpoints.push(21.0975);
        }
        checkpoints.push(targetKm);
        checkpoints.sort((a, b) => a - b);

        checkpoints.forEach((checkpoint) => {
          const card = document.createElement('div');
          card.className = 'altar-calculators__split-card';
          const label = document.createElement('span');
          const isFinish = Math.abs(checkpoint - targetKm) < 0.001;
          const isHalf = Math.abs(checkpoint - 21.0975) < 0.001 && targetKm > 21.0975;
          label.textContent = isFinish ? 'Finish' : (isHalf ? 'Half Marathon' : `${checkpoint} km`);
          const strong = document.createElement('strong');
          strong.textContent = formatDuration(targetSeconds * (checkpoint / targetKm));
          card.append(label, strong);
          splitsWrap.appendChild(card);
        });

        raceResults.hidden = false;
      });

      const fuelForm = root.querySelector('[data-fuel-form]');
      const fuelError = root.querySelector('[data-fuel-error]');
      const fuelResults = root.querySelector('[data-fuel-results]');
      const fuelActivity = root.querySelector('[data-fuel-activity]');
      const fuelPurpose = root.querySelector('[data-fuel-purpose]');
      const runningRaceFields = root.querySelector('[data-running-race-fields]');
      const fuelRaceDistance = root.querySelector('[data-fuel-race-distance]');
      const customFuelDistanceWrap = root.querySelector('[data-custom-fuel-distance-wrap]');
      const customFuelDistance = root.querySelector('[data-custom-fuel-distance]');

      function syncFuelRaceFields() {
        const showRaceDistance = fuelActivity?.value === 'running' && fuelPurpose?.value === 'race';
        if (runningRaceFields) runningRaceFields.hidden = !showRaceDistance;

        const showCustomDistance = showRaceDistance && fuelRaceDistance?.value === 'custom';
        if (customFuelDistanceWrap) customFuelDistanceWrap.hidden = !showCustomDistance;
        if (customFuelDistance) customFuelDistance.required = showCustomDistance;
      }

      fuelActivity?.addEventListener('change', syncFuelRaceFields);
      fuelPurpose?.addEventListener('change', syncFuelRaceFields);
      fuelRaceDistance?.addEventListener('change', syncFuelRaceFields);
      syncFuelRaceFields();

      fuelForm?.addEventListener('submit', (event) => {
        event.preventDefault();
        if (!fuelError || !fuelResults) return;

        fuelError.hidden = true;
        fuelError.textContent = '';

        const hours = numberValue(root.querySelector('[data-fuel-hours]'), 0);
        const minutes = numberValue(root.querySelector('[data-fuel-minutes]'), 0);
        const durationMinutes = (hours * 60) + minutes;
        const activity = fuelActivity?.value ?? 'running';
        const purpose = fuelPurpose?.value ?? 'race';
        const intensity = root.querySelector('[data-fuel-intensity]')?.value ?? 'race';
        const experience = root.querySelector('[data-fuel-experience]')?.value ?? 'some';
        const isRunningRace = activity === 'running' && purpose === 'race';
        const raceDistanceKm = isRunningRace
          ? (fuelRaceDistance?.value === 'custom'
            ? numberValue(customFuelDistance, 0)
            : Number.parseFloat(fuelRaceDistance?.value ?? '42.195'))
          : null;

        if (minutes < 0 || minutes > 59 || durationMinutes < 15 || durationMinutes > 1440) {
          fuelError.textContent = 'Enter an expected duration between 15 minutes and 24 hours.';
          fuelError.hidden = false;
          fuelResults.hidden = true;
          return;
        }

        if (isRunningRace && (!Number.isFinite(raceDistanceKm) || raceDistanceKm < 1 || raceDistanceKm > 500)) {
          fuelError.textContent = 'Enter a valid running race distance between 1 km and 500 km.';
          fuelError.hidden = false;
          fuelResults.hidden = true;
          return;
        }

        const range = getFuelRange(durationMinutes, activity, purpose, raceDistanceKm);
        const target = fuelTarget(range, intensity, experience, purpose, durationMinutes, activity, raceDistanceKm);
        const durationHours = durationMinutes / 60;
        const totalCarbs = Math.round(target * durationHours);
        const carbsPerServing = Math.max(1, Number.parseFloat(root.dataset.carbsPerServing || '71'));
        const scoopsPerServing = Math.max(1, Number.parseFloat(root.dataset.scoopsPerServing || '3'));
        const waterPerServing = Math.max(1, Number.parseFloat(root.dataset.waterPerServing || '500'));
        const servings = target > 0 ? totalCarbs / carbsPerServing : 0;
        const servingsPerHour = target > 0 ? target / carbsPerServing : 0;

        root.querySelector('[data-fuel-target]').textContent = String(target);
        root.querySelector('[data-fuel-range]').textContent = range.label;
        root.querySelector('[data-fuel-total]').textContent = target > 0 ? `≈ ${totalCarbs} g` : 'Optional';
        root.querySelector('[data-fuel-servings]').textContent = target > 0 ? `≈ ${servings.toFixed(1)} servings` : '0 servings';

        const basis = root.querySelector('[data-fuel-basis]');
        if (basis) {
          const experienceLabel = {
            new: 'New to fuelling',
            some: 'Some fuelling experience',
            trained: 'Well practised / gut trained'
          }[experience] ?? 'Fuelling experience selected';

          if (isRunningRace && Number.isFinite(raceDistanceKm)) {
            const raceLabels = [
              [5, '5K'],
              [10, '10K'],
              [16.09344, '10 Mile'],
              [21.0975, 'Half Marathon'],
              [42.195, 'Marathon'],
              [50, '50K'],
              [80.4672, '50 Mile'],
              [100, '100K']
            ];
            const matched = raceLabels.find(([distance]) => Math.abs(distance - raceDistanceKm) < 0.02);
            const raceLabel = matched ? matched[1] : `${raceDistanceKm.toFixed(1)} km`;
            const paceSeconds = (durationMinutes * 60) / raceDistanceKm;
            basis.textContent = `Based on: ${raceLabel} · ${formatDuration(durationMinutes * 60)} target · ${formatPace(paceSeconds)}/km · ${experienceLabel}`;
          } else {
            basis.textContent = `Based on: ${formatDuration(durationMinutes * 60)} · ${purpose === 'race' ? 'Competition' : 'Training'} · ${experienceLabel}`;
          }
        }

        const beforeText = root.querySelector('[data-fuel-before]');
        if (durationMinutes >= 90 || purpose === 'race' || intensity === 'hard' || intensity === 'race') {
          beforeText.textContent = `ALTAR starting point: 1 standard serving (${carbsPerServing}g) sipped steadily over the 45–60 min before starting.`;
        } else {
          beforeText.textContent = 'Arrive normally fuelled. A pre-session serving is optional for shorter or easier training.';
        }

        const duringText = root.querySelector('[data-fuel-during]');
        if (target === 0) {
          duringText.textContent = 'Carbohydrate during the session is generally optional at this duration.';
        } else {
          duringText.textContent = `Aim for about ${target}g/h, or roughly ${servingsPerHour.toFixed(1)} standard Speed Dust servings per hour, distributed consistently.`;
        }

        const practicalText = root.querySelector('[data-fuel-practical]');
        if (target === 0) {
          practicalText.textContent = 'Focus on starting fuelled and use fluid according to thirst, conditions and your usual strategy.';
        } else if (Math.abs(target - carbsPerServing) <= 10) {
          practicalText.textContent = `1 standard serving per hour provides ${carbsPerServing}g/h, which sits close to this target. Start early and sip consistently.`;
        } else if (target < carbsPerServing - 10) {
          practicalText.textContent = `A full serving every hour would exceed this starting target. Use the session total (≈${servings.toFixed(1)} servings) and spread it across the effort.`;
        } else {
          practicalText.textContent = `1 standard serving per hour provides ${carbsPerServing}g/h. Reaching the higher target requires additional carbohydrate and should be practised progressively in training.`;
        }

        const guidance = root.querySelector('[data-fuel-guidance]');
        guidance.replaceChildren();
        const notes = [];

        if (durationMinutes <= 45) {
          notes.push('For most athletes, carbohydrate during exercise is not necessary for a session this short.');
        } else if (durationMinutes <= 75) {
          notes.push('For hard efforts around an hour, small carbohydrate amounts can be useful; large intakes are usually unnecessary.');
        } else if (isRunningRace && Number.isFinite(raceDistanceKm) && raceDistanceKm >= 42.195) {
          notes.push('For marathon and ultra racing, this calculator uses a 60–90g carbohydrate per hour performance range and places you within it according to fuelling experience.');
        } else if (durationMinutes <= 150) {
          notes.push('For 75–150 minute endurance work, 30–60g carbohydrate per hour remains a common guideline range.');
        } else {
          notes.push('For prolonged endurance events beyond about 2.5 hours, 60–90g carbohydrate per hour is a common performance range when well tolerated.');
        }

        if (experience === 'new' && target > 0) {
          notes.push('Because you selected “new to fuelling”, start toward the lower end and build tolerance over repeated training sessions.');
        } else if (experience === 'trained' && target >= 75) {
          notes.push('Higher carbohydrate intakes are most appropriate when they have been practised repeatedly in training.');
        }

        if (activity === 'hyrox') {
          notes.push('For HYROX, intake opportunities can be limited at high intensity. Practise small, easy-to-tolerate sips around your station strategy.');
        }

        notes.push(`A standard Speed Dust serving in this calculator is ${scoopsPerServing} scoops with ${waterPerServing}ml water, providing ${carbsPerServing}g carbohydrate.`);
        notes.push('Carbohydrate and fluid requirements are not identical. Adjust fluid intake for temperature, sweat rate and personal tolerance rather than forcing a fixed volume.');

        notes.forEach((note) => {
          const paragraph = document.createElement('p');
          paragraph.textContent = note;
          guidance.appendChild(paragraph);
        });

        fuelResults.hidden = false;
      });
    }

    function initializeAll(scope = document) {
      scope.querySelectorAll('[data-altar-calculators]').forEach(initializeCalculator);
    }

    initializeAll();

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) {
        if (event.target.matches('[data-altar-calculators]')) {
          initializeCalculator(event.target);
        } else {
          initializeAll(event.target);
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carb-cartel-portal"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('altar-cartel-portal')) {
    class AltarCartelPortal extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('.cc-portal__footer')) {
          this.initialize();
          return;
        }
        this.childObserver = new MutationObserver(() => {
          if (!this.querySelector('.cc-portal__footer')) return;
          this.childObserver.disconnect();
          this.initialize();
        });
        this.childObserver.observe(this, {childList: true, subtree: true});
      }
      initialize() {
        this.dates = {};
        for (const key of ['opens', 'closes', 'results']) this.dates[key] = this.parseDate(this.dataset[key]);
        this.scheduleValid = Number.isFinite(this.dates.opens) && this.dates.closes > this.dates.opens && this.dates.results > this.dates.closes;
        this.ready = this.dataset.hasApp === 'true' && this.dataset.hasPrice === 'true' && this.scheduleValid;
        this.nodes = Array.from(this.querySelectorAll('[data-cc-visible]'));
        this.form = this.querySelector('[data-cc-form]');
        this.clock = this.querySelector('[data-cc-clock]');
        this.clockLabel = this.querySelector('[data-cc-clock-label]');
        this.units = Object.fromEntries(Array.from(this.querySelectorAll('[data-cc-unit]')).map(node => [node.dataset.ccUnit, node]));
        this.formatDates();
        this.tick();
        clearInterval(this.timer);
        this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        if (this.childObserver) this.childObserver.disconnect();
      }
      parseDate(value) {
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2}(?:\.\d{1,3})?)?(?:Z|[+-]\d{2}:\d{2})$/.test(value || '')) return NaN;
        return Date.parse(value);
      }
      formatDates() {
        let formatter;
        try {
          formatter = new Intl.DateTimeFormat(this.dataset.locale || 'en-IE', {timeZone: this.dataset.timezone || 'Europe/Dublin', day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZoneName: 'short', hour12: false});
        } catch { return; }
        for (const node of this.querySelectorAll('[data-cc-date]')) {
          const timestamp = this.dates[node.dataset.ccDate];
          if (Number.isFinite(timestamp)) node.textContent = formatter.format(timestamp);
        }
      }
      stateAt(now) {
        if (this.dataset.mode === 'closed') return 'closed';
        if (this.dataset.mode === 'results') return 'results';
        if (this.dataset.mode !== 'scheduled' || !this.ready) return 'upcoming';
        if (now >= this.dates.closes) return 'closed';
        return now >= this.dates.opens ? 'open' : 'upcoming';
      }
      tick() {
        const now = Date.now();
        const state = this.stateAt(now);
        if (this.currentState !== state) {
          this.dataset.state = state;
          this.nodes.forEach(node => { node.hidden = node.dataset.ccVisible !== state; });
          if (this.form) this.form.hidden = state !== 'open' && !(window.Shopify && window.Shopify.designMode);
          this.currentState = state;
        }
        const target = state === 'upcoming' ? this.dates.opens : state === 'open' ? this.dates.closes : state === 'closed' ? this.dates.results : NaN;
        this.clock.hidden = !Number.isFinite(target) || target <= now;
        if (this.clock.hidden) return;
        this.clockLabel.textContent = this.dataset['clock' + state.charAt(0).toUpperCase() + state.slice(1)];
        const left = Math.max(0, Math.ceil((target - now) / 1000));
        const units = {days: Math.floor(left / 86400), hours: Math.floor(left % 86400 / 3600), minutes: Math.floor(left % 3600 / 60), seconds: left % 60};
        for (const [key, value] of Object.entries(units)) this.units[key].textContent = String(value).padStart(2, '0');
      }
    }
    customElements.define('altar-cartel-portal', AltarCartelPortal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
